import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { SingleSurveyPage } from '../survey/survey';
import { CreateTechSurveyPage } from '../create-tech-survey/create-tech-survey';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { LeadDetailPage } from '../lead-detail-page/lead-detail-page';
import { SearchPage } from '../search/search';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
//import * as Survey from 'survey-angular';
import { Http } from '@angular/http';
import { Geolocation } from '@ionic-native/geolocation';



@Component({
  selector: 'lead-page',
  templateUrl: 'lead-page.html',
})
export class LeadPage {
  errorMessage = '';
  goHighLevelLeads = new Array;
  loadedLeads = new Array;

  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public loading: LoadingProvider,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    private geolocation: Geolocation,
    public alert: AlertProvider
  ) {
  }



getItems(searchbar){
  // Reset items back to all of the items
  this.initializeItems();
  // set q to the value of the searchbar
  var q = searchbar.srcElement.value;

  // if the value is an empty string don't filter the items
   if (!q) {
     return;
   }

   this.goHighLevelLeads = this.goHighLevelLeads.filter((v) => {

 if(v.name && q) {
   if (v.name.toLowerCase().indexOf(q.toLowerCase()) > -1) {
     return true;
   }
   return false;
 }
});


};

initializeItems(): void {
this.goHighLevelLeads = this.loadedLeads;
}

ionViewWillEnter() {

}

showLeadDetail(lead){
  console.log("Got Lead Detail:",lead);
  this.navCtrl.push(LeadDetailPage, { lead: lead.contact });
}


SendPhotoSurvey(lead){

  swal({title: "Send Photo Survey Link ?",text:
  "This will send a link via SMS to " + lead.contact.phone ,icon: "info",buttons:
  ['No','Yes']}).then((willDelete) => {
  if (willDelete) {


      this.loading.show();
      console.log("Send Photo Survey:",lead);
      var index = lead.contact.name.indexOf(' ');
      var arr = [lead.contact.name.slice(0, index), lead.contact.name.slice(index + 1)];
      let firstName = arr[0];
      let secondName = arr[1];
      let self_surveyURL = this.shared.customerData.self_surveyURL;
      let customer_id = this.shared.customerData.customers_id;
      let companyname = this.shared.customerData.companyname;

      console.log(arr[0] + " " + arr[1]);
      console.log("Name: " , lead.contact.name);
      console.log("URL: " , self_surveyURL);


      var data = {
        "delivery_firstname":firstName,
      "delivery_lastname":secondName,
      "customers_telephone":lead.contact.phone,
      "self_surveyURL":self_surveyURL,
      "companyname":companyname,
      "customer_id":customer_id
      };
      this.http.post(this.config.url + 'sendSelfSurveyLink', data).map(res => res.json()).subscribe(data => {



        if (data.success == 1) {
          console.log("Success");
          this.loading.hide();
          swal({title: "Success!",text: "Survey Link is on its Way!",icon: "success"}).then((value) => {
              //this.navCtrl.push(HomePage);
              this.navCtrl.popToRoot()
          });

        }
        if (data.success == 0)
        {
          this.loading.hide();
          swal({title: "Sorry!",text: "Something is not right. Try again later",icon: "error"}).then((value) => {
              //this.navCtrl.push(HomePage);
          });

        }


      }, err => {
        this.loading.hide();
        swal({title: "Sorry!",text: "Something is not right. Try again later",icon: "error"}).then((value) => {
            //this.navCtrl.push(HomePage);
        });
      });



  }
})




}

StartQuote(lead){
  console.log("Start Quote:",lead);

  this.getCustomer(lead);
  //this.getMessages(lead);
  //this.navCtrl.push(HomePage, { lead: lead });

}


getCustomer(lead){

  var data: { [k: string]: any } = {};
  console.log("Getting contact for:",lead);
  data.customer_id = lead.contact.id;
  data.ghl_token = this.shared.customerData.ghl_token;
  this.loading.show();
  this.http.post(this.config.url + 'getCustomer', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {


      console.log("Got Customer:",data.customer);
      this.shared.orderDetails.delivery_firstname = data.customer.contact.firstName;
      this.shared.orderDetails.delivery_lastname = data.customer.contact.lastName;
      this.shared.orderDetails.customers_telephone = data.customer.contact.phone;
      this.shared.orderDetails.delivery_postcode = data.customer.contact.postalCode;
      this.navCtrl.push(HomePage, { lead: data.customer });



      }
    });


}

ngOnInit() {
console.log("This is the customer:",this.shared.customerData);
this.getLeads();
}

getLeads = function (){
  var data: { [k: string]: any } = {};
  console.log("Get Leads");
  data.ghl_pipeline_id = this.shared.customerData.ghl_lead_pipeline_id;
  data.ghl_token = this.shared.customerData.ghl_token;
  this.loading.show();
  this.http.post(this.config.url + 'getLeads', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {

      this.goHighLevelLeads = data.leads.opportunities;
      this.loadedLeads = this.goHighLevelLeads;
      console.log("Got Leads:",this.goHighLevelLeads);
    //this.contentArea.scrollToBottom(300);



      }
    });
}
}



// WEBPACK FOOTER //
// ./src/pages/lead-page/lead-page.ts